module.exports = "/static/assets/de787f0af75a8a6da1e40057c7b01199.png";